import { render } from "./PremiumIcon.vue?vue&type=template&id=69a01ba6"
import script from "./PremiumIcon.vue?vue&type=script&lang=js"
export * from "./PremiumIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__